import { useEffect, useState } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import EditIcon from "../../../components/Icons/EditIcon";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { Nav, NavItem, NavLink, TabContent, Fade, TabPane } from "reactstrap";
import ViewIcon from "../../../components/Icons/ViewIcon";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  saveActivePurchaseTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import ExportDataHandler from "../../../utility/ExportDataHandler";

export default function Purchase() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timeoutId = useRef(null);
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  let ActiveTab = useSelector((state) => state?.root?.activePurchaseTab);

  useEffect(() => {
    if (!ActiveTab) {
      if (userDetails?.department?.name === "SCM" && userDetails?.type === 1) {
        dispatch(saveActivePurchaseTab("pending"));
      } else if (userDetails?.type === 2) {
        dispatch(saveActivePurchaseTab("created"));
      }
    }
  }, [userDetails, ActiveTab, dispatch]);

  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    purchaseData: [],
    pendingPurchaseData: [],
    searchQuery: "",
    type: "",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    isLoadingSite: false,
    companyIsLoading: false,
    isInitial: true,
  });

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  const toggleTab = (tab) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
        pageSize: 10,
        requestType: "",
        stockStatus: "",
        vendorId: "",
      })
    );
    dispatch(saveActivePurchaseTab(tab));
    GetSiteList();
  };

  useEffect(() => {
    if (ActiveTab === "pending") {
      if (filterDetails?.year) {
        GetPendingPurchaseList();
      }
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    ActiveTab,
    filterDetails.pageSize,
    filterDetails.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    filterDetails?.companyId,
    filterDetails?.requestType,
    filterDetails?.vendorId,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    if (ActiveTab !== "pending") {
      if (filterDetails?.year) {
        GetPurchaseList();
      }
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails.pageSize,
    filterDetails.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    ActiveTab,
    filterDetails?.companyId,
    filterDetails?.requestType,
    filterDetails?.stockStatus,
    filterDetails?.vendorId,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  const GetPurchaseList = () => {
    let options = {
      method: "GET",
    };
    let filteredPageStates = {
      status: ActiveTab === "all" ? "" : ActiveTab,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
      ...filterDetails,
    };
    delete filteredPageStates.type;
    // console.log(filteredPageStates)

    let API = apiUrl.get_purchase + MainFilterHandler(filteredPageStates);

    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.purchase?.map((item) => ({
          ...item,
          purchaceRequestNumber: item?.purchaserequest?.requestNumber,
          date: moment(item?.purchaseDate).format("DD-MM-YYYY"),
          siteName: item?.purchaserequest?.site?.name,
          vendorName: item?.vendor?.name,
          totalAmounts: formatAmount(item?.totalAmount),
          purchaseRequestStatus: item?.status,
          reqType:
            item?.purchaserequest?.type === "supplyRequest"
              ? "Supply Request"
              : "Service Request",
          stockStatus:
            item?.purchaserequest?.type === "supplyRequest"
              ? item?.isAllItemReceived
              : "--",
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          purchaseData: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetPendingPurchaseList = () => {
    let options = {
      method: "GET",
    };
    const filterData = {
      status: pageStates?.status,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
      ...filterDetails,
    };
    delete filterData.vendorId;
    let API =
      apiUrl.get_purchase_request +
      "?from=purchase&status=pending&" +
      MainFilterHandler(filterData);
    // console.log("URL", API)
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.purchaseRequest?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          person: item?.user?.name,
          bookingDate: item?.date
            ? moment(item?.date).format("DD-MM-YYYY")
            : "--",
          ExpectedDate: item?.expectedDate
            ? moment(item?.expectedDate).format("DD-MM-YYYY")
            : "--",
          purchaseRequestStatus: item?.status,
          reqType:
            item?.type === "supplyRequest"
              ? "Supply Request"
              : "Service Request",
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          pendingPurchaseData: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const HandleEdit = (data) => {
    if (data?.isInBudgetRequest) {
      toast.info("Can't update PO when it is requested for Increase Budget");
    } else {
      navigate(RoutesLink?.create_purchase, {
        state: { data: data, type: "Edit" },
      });
    }
  };

  // const HandleDelete = () => {
  //   let options = {
  //     method: "GET",
  //   };
  //   let API = apiUrl.delete_customer + `?customerId=${selectedId}`;
  //   setIsLoading(true);
  //   callApi(API, options).then((response) => {
  //     setIsLoading(false);
  //     if (response?.status === true) {
  //       toast.success(response?.message);
  //       toggle();
  //       GetCustomerList(pageStates?.currentPage);
  //     } else {
  //       toast.error(response?.message);
  //       toggle();
  //     }
  //   });
  // };

  const HandleView = (data) => {
    navigate(RoutesLink.purchase_order_detail + `/${data?.id}`);
  };

  const HandleViewPending = (data) => {
    navigate(RoutesLink.purchase_request_detail + `/${data?.id}`);
  };


  const TableHeading = [
    { value: "purchaseNumber", label: "PO No." },
    { value: "purchaceRequestNumber", label: "PR No." },
    { value: "date", label: "Date" },
    { value: "siteName", label: "Site Name" },
    { value: "vendorName", label: "Vendor" },
    { value: "reqType", label: "Type" },
    { value: "totalAmounts", label: "Total Amount" },
    { value: "purchaseRequestStatus", label: "Status" },
  ];
  const TableHeadingPurchase = [
    { value: "requestNumber", label: "Request No." },
    { value: "bookingDate", label: "Created At" },
    { value: "ExpectedDate", label: "Expected At" },
    { value: "siteName", label: "Site Name" },
    { value: "person", label: "Created By" },
    { value: "reqType", label: "Type" },
    { value: "purchaseRequestStatus", label: "Status" },
  ];
  const TableHeadingApproved = [
    { value: "purchaseNumber", label: "PO No." },
    { value: "purchaceRequestNumber", label: "PR No." },
    { value: "date", label: "Date" },
    { value: "siteName", label: "Site Name" },
    { value: "vendorName", label: "Vendor" },
    { value: "reqType", label: "Type" },
    { value: "stockStatus", label: "Stock Status" },
    { value: "totalAmounts", label: "Total Amount" },
    { value: "purchaseRequestStatus", label: "Status" },
  ];

  const ActionDataPending = [
    // ...(!( userDetails?.department?.name === "SCM")
    //          ? [
    //              {
    //               label: "Update",
    //      className: "btn btn-link",
    //      icon: <EditIcon />,
    //      title: "update",
    //      clickHandler: HandleUpdate,
    //              },
    //            ]
    //          : []),
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleViewPending,
    },
  ];


  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];
  const ActionDataForPOCreated = [
    {
      label: "Edit Purchase",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "Edit Purchase",
      clickHandler: HandleEdit,
    },
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: false,
    companyList: pageStates?.companyList,
    requestTypeList: [
      { label: "All Type", value: "" },
      { label: "Supply Request", value: "supplyRequest" },
      { label: "Service Request", value: "serviceRequest" },
    ],
    ...(ActiveTab === "approved" && {
      stockTypeList: [
        { label: "All Type", value: "" },
        { label: "Pending", value: 0 },
        { label: "Partial", value: 1 },
        { label: "Received", value: 2 },
      ],
    }),
  };

  const handleSortData = (data, type = null) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId }),
        ...(!type && { requestType: data?.requestType }),
        ...(!type && { stockStatus: data?.stockStatus }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );
    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const handleExport = () => {
    let filterData = {
      exportDataType: ActiveTab === "pending" ? "purchaseRequest" : "purchase",
      status:
        ActiveTab === "pending"
          ? pageStates?.status
          : ActiveTab === "all"
            ? ""
            : ActiveTab,
      searchQuery: pageStates?.searchQuery,
      ...filterDetails,
    };
    if (ActiveTab === "pending") {
      delete filterData.vendorId;
    } else {
      delete filterData.type;
    }
    delete filterData?.currentPage;
    delete filterData?.pageSize;
    delete filterData?.count;
    delete filterData?.totalPages;
    ExportDataHandler(filterData);
  };

  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Purchase"}
            dateChangeHandler={dateChangeHandler}
            handleYearChange={handleYearChange}
          // showDefaultDate={true}
          />
          {
            <Nav tabs className="nav nav-tabs border-0 mb-4">
              {userDetails?.type != 2 && (
                <NavItem className="nav-item ">
                  <NavLink
                    className={
                      ActiveTab === "pending"
                        ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-1 active"
                        : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-1"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab("pending")}
                    disabled={pageStates?.tableLoader}
                  >
                    Pending PR
                  </NavLink>
                </NavItem>
              )}
              <NavItem className="nav-item">
                <NavLink
                  className={
                    ActiveTab === "created"
                      ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-2 active"
                      : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-2"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab("created")}
                  disabled={pageStates?.tableLoader}
                >
                  PO Created
                </NavLink>
              </NavItem>
              <NavItem className="nav-item ">
                <NavLink
                  className={
                    ActiveTab === "approved"
                      ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                      : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab("approved")}
                  disabled={pageStates?.tableLoader}
                >
                  Approved
                </NavLink>
              </NavItem>
              <NavItem className="nav-item ">
                <NavLink
                  className={
                    ActiveTab === "closed"
                      ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                      : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab("closed")}
                  disabled={pageStates?.tableLoader}
                >
                  Short Closed
                </NavLink>
              </NavItem>
              <NavItem className="nav-item ">
                <NavLink
                  className={
                    ActiveTab === "rejected"
                      ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                      : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab("rejected")}
                  disabled={pageStates?.tableLoader}
                >
                  Rejected
                </NavLink>
              </NavItem>
            </Nav>
          }

          <TabContent activeTab={ActiveTab}>
            <TabPane tabId={"pending"}>
              <Fade in={ActiveTab === "pending"} timeout={200}>
                <div className="card mb-4">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleSortData}
                      pageStates={pageStates}
                      sortHandler={handleSortData}
                      handleExport={
                        pageStates?.pendingPurchaseData?.length > 0
                          ? handleExport
                          : null
                      }
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeadingPurchase}
                      TableData={pageStates?.pendingPurchaseData}
                      ActionData={ActionDataPending}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      pageSize={filterDetails.pageSize}
                      handleChangePageSize={handleChangePageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={"created"}>
              <Fade in={ActiveTab === "created"} timeout={200}>
                <div className="card mb-4">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      searchPlaceHolder={"Search By PO No."}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleSortData}
                      pageStates={pageStates}
                      sortHandler={handleSortData}
                      isShowVendorFilter={ActiveTab === "created"}
                      handleExport={
                        pageStates?.purchaseData?.length > 0
                          ? handleExport
                          : null
                      }
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={pageStates?.purchaseData}
                      ActionData={ActionDataForPOCreated}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={"approved"}>
              <Fade in={ActiveTab === "approved"} timeout={200}>
                <div className="card mb-4">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleSortData}
                      pageStates={pageStates}
                      sortHandler={handleSortData}
                      isShowVendorFilter={ActiveTab === "approved"}
                      handleExport={
                        pageStates?.purchaseData?.length > 0
                          ? handleExport
                          : null
                      }
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeadingApproved}
                      TableData={pageStates?.purchaseData}
                      ActionData={ActionData}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={"closed"}>
              <Fade in={ActiveTab === "closed"} timeout={200}>
                <div className="card mb-4">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleSortData}
                      pageStates={pageStates}
                      sortHandler={handleSortData}
                      isShowVendorFilter={ActiveTab === "closed"}
                      handleExport={
                        pageStates?.purchaseData?.length > 0
                          ? handleExport
                          : null
                      }
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={pageStates?.purchaseData}
                      ActionData={ActionData}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={"rejected"}>
              <Fade in={ActiveTab === "rejected"} timeout={200}>
                <div className="card mb-4">
                  <div className="card-body">
                    <FilterComponent
                      handleSearch={handleSearchChange}
                      filterArray={sortList}
                      typeFilter={true}
                      handleData={handleSortData}
                      pageStates={pageStates}
                      sortHandler={handleSortData}
                      isShowVendorFilter={ActiveTab === "rejected"}
                      handleExport={
                        pageStates?.purchaseData?.length > 0
                          ? handleExport
                          : null
                      }
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={pageStates?.purchaseData}
                      ActionData={ActionData}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
          </TabContent>
        </div>
      </>
      {/* <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      /> */}
    </>
  );
}
